import React, { Component } from 'react';
import Raven from 'raven-js';
import Responsive from 'react-responsive';
import { Provider, connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createStore } from 'redux';
import { Spin } from 'antd';
import { reducer, isReturning } from './redux/util';
import DesktopOptimizer from './optimizer/DesktopOptimizer';
import MobileOptimizer from './optimizer/MobileOptimizer';
import Research from './Research';
import LoginForm from './user/Login';
import SignupForm from './user/SignUp';
import Profile from './user/Profile';
import About from './About';
import { fetchWithToken } from './network';

const MOBILE_BREAK = 735;
const VERSION = 'v5.3.0';
const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

if (!IS_DEV) {
  Raven.config(
    'https://697b81b59c4f42ff94b911cf086f39be@sentry.io/1198275',
  ).install();
}

class ErrorBoundary extends Component {
  state = { error: null, loading: null };

  componentDidCatch(error, info) {
    Raven.captureException(error, info);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="Error">
          Something went wrong. We have been informed of this issue, but please
          contact ben.brostoff@gmail.com if you have questions.
        </div>
      );
    }

    return this.props.children;
  }
}

let store;
if (IS_DEV) {
  store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
} else {
  store = createStore(reducer);
}

const App = props => {
  const Mobile = props => <Responsive {...props} maxWidth={MOBILE_BREAK} />;
  const Desktop = props => <Responsive {...props} minWidth={MOBILE_BREAK} />;

  const Optimizer = () => (
    <div>
      <Mobile>
        <MobileOptimizer version={VERSION} />
      </Mobile>
      <Desktop>
        <DesktopOptimizer version={VERSION} />
      </Desktop>
    </div>
  );

  return (
    <BrowserRouter>
      <Provider store={store}>
        <ErrorBoundary>
          <Switch>
            <Route path="/about" component={About} />
            <Route path="/login" component={LoginForm} />
            <Route path="/research" component={Research}/>
            <Route path="/sign-up" component={SignupForm} />
            <Route path="/profile" component={Profile} />
            <Route path="/" component={Optimizer} />
          </Switch>
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  );
};

class LoginApp extends Component {
  state = {
    loading: true,
  };

  setUserIfExists = async () => {
    let user = null;
    let projections = null;

    const res = await fetchWithToken('rest-auth/user/', {
      withJSON: false,
    });
    if (res.status === 200) {
      user = await res.json();
    }

    this.setState({
      user,
      projections,
      loading: false,
    });
  };

  componentDidMount() {
    this.setUserIfExists();
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="App">
          <Spin size="large" />
        </div>
      );
    }

    this.props.storeUser(this.state.user, this.state.projections);

    return <App />;
  }
}

const mapStateToProps = () => {
  return {};
};

const ReduxApp = connect(mapStateToProps, dispatch => {
  return {
    storeUser: (user, projections, token) =>
      dispatch(isReturning(user, projections, token)),
  };
})(LoginApp);

export default props => (
  <Provider store={store}>
    <ReduxApp {...props} />
  </Provider>
);



// WEBPACK FOOTER //
// ./src/App.js